import { IGiveawayParticipant } from "../../../interfaces";



class GiveawayParticipantMapper {
    toPersistence(domainGiveawayParticipant: IGiveawayParticipant): any {
        return {
            id: domainGiveawayParticipant.id,
            name: domainGiveawayParticipant.name,
            cpf: domainGiveawayParticipant.cpf,
            phone: domainGiveawayParticipant.phone,
            balance_tickets: domainGiveawayParticipant.balance_tickets,
            total_tickets: domainGiveawayParticipant.total_tickets,
        }
    }

    toDomain(persistenceGiveawayParticipant: any): IGiveawayParticipant {
        return {
            id: persistenceGiveawayParticipant.id,
            name: persistenceGiveawayParticipant.name,
            cpf: persistenceGiveawayParticipant.cpf,
            phone: persistenceGiveawayParticipant.phone,
            balance_tickets: persistenceGiveawayParticipant.balance_tickets,
            total_tickets: persistenceGiveawayParticipant.total_tickets,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new GiveawayParticipantMapper();
